var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84 12H32L0 48l32 36h52c6.627 0 12-5.373 12-12V24c0-6.627-5.373-12-12-12zm4 60c0 2.206-1.794 4-4 4H35.593L10.704 48l24.889-28H84c2.206 0 4 1.794 4 4v48zM74.828 57.172a4 4 0 1 1-5.656 5.656L60 53.657l-9.172 9.171C50.047 63.609 49.023 64 48 64s-2.047-.391-2.828-1.172a4 4 0 0 1 0-5.656L54.343 48l-9.171-9.172a4 4 0 1 1 5.656-5.656L60 42.343l9.172-9.171a4 4 0 1 1 5.656 5.656L65.657 48l9.171 9.172z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.21cd4457.svg";
export { ForwardRef as ReactComponent };